import { AfterViewInit, ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy } from "@angular/core";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { ReadonlyFieldStateService } from "./readonly-field-state.service";

@Component({
    selector: "common-readonly-field",
    templateUrl: "./common-readonly-field.component.html",
    providers: [
        CommonFieldManagerDirective,
        {
            provide: FieldStateService,
            useClass: ReadonlyFieldStateService,
        },
        { provide: FIELD_TOKEN, useValue: "commonFormReadonlyFields" },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonReadonlyFieldComponent implements AfterViewInit, OnDestroy {
    @Input() public isDisplayed = true;
    @HostBinding("class.u-display-flex") public isFlex = true;

    constructor(
        public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
    ) { }

    public ngAfterViewInit() {
        const state = this.fieldStateService.stateObservable$.getValue();
        this.fieldManager.dispatchFormFieldChange(state.value);
    }

    public ngOnDestroy() {
        this.fieldManager.resetState();
        this.fieldManager.removeFromForm();
    }
}
